<div class="app-isf-ocr-quick-fix-manufacturer-details">
  <div class="app-isf-ocr-quick-fix-manufacturer-details__header">
    <div class="app-isf-ocr-quick-fix-manufacturer-details__header__left">
      <p class="app-isf-ocr-quick-fix-manufacturer-details__header__title">
        {{ manufacturerTitle | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.MF.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-manufacturer-details__row">
    <p class="app-isf-ocr-quick-fix-manufacturer-details__text m-0">
      {{ "INFO.MF.SUB_TITLE" | translate }}
    </p>
    <p *ngIf="!!seller && isEditMode && !isSellerAssignedToOtherManufacturer" class="app-isf-ocr-quick-fix-manufacturer-details__hint-text">
      {{ "LABELS.USE_PREV_INFO" | translate }}
    </p>
  </div>

  <div class="app-isf-ocr-quick-fix-manufacturer-details__row">
    <app-entity-unify-card
      *ngIf="!!seller && isEditMode && !isSellerAssignedToOtherManufacturer"
      [entity]="seller"
      [formGroup]="formGroup"
      [code]="enumEntityModelCode.MANUFACTURER"
      [selectedValueControl]="formGroup.get('id')"
      [labelOverride]="'INFO.MF.USE_SE'"
      [isDesktop]="isDesktop"
    ></app-entity-unify-card>
  </div>

  <div class="app-isf-ocr-quick-fix-manufacturer-details__row">
    <app-section-form-block-layout
      *ngIf="!!manufacturerFields"
      [formGroup]="formGroup"
      [editBlockDescription]="!!seller && isEditMode && !isSellerAssignedToOtherManufacturer ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="manufacturerFields"
      [displayFields]="manufacturerDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(manufacturerFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.MANUFACTURER"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-manufacturer-details__hr" />

    <div class="app-isf-ocr-quick-fix-manufacturer-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
